import React from "react"
import dayjs from "dayjs";

function ExternalUpdatesTable(props){

    const {data, dataKey, title, noElementsMessage} = props;
 
    return(
        <div style={{marginTop: "5px", marginBottom: "5px"}}>
        {
            data && data.length > 0 ?
                <>
                <div style={{color:"#3B5158",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <span style={{color:"#3B5158", marginBottom:"2px"}}>{title}</span>
                </div>
                    <table className="callTable">
                        <tbody>
                        {data.length>0&&data.map((e, i)=>{
                            return(
                            <tr className="callTableTr" key={`e.callId-${i}`}>
                                <td className="callTableTd" style={{backgroundColor:"#fcfcfc", marginRight:"12px"}}>{e[dataKey]}</td>
                                <td className="callTableTd" style={{backgroundColor:"#fcfcfc", minWidth:"50px"}}>{dayjs(e.date).format("DD/MM/YYYY HH:mm:ss")}</td> 
                            </tr>)})
                        }
                        </tbody>
                    </table> 
                    </> :
                    <div style={{width:"100%", fontWeight:"bold", color:"#3B5158"}}>
                       <div style={{color:"#3B5158",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                            <span style={{color:"#3B5158"}}>{noElementsMessage}</span>
                        </div>
                </div>
            }
        </div>
            
    )
}

export {ExternalUpdatesTable}